/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-unused-expressions */
/* eslint-disable unused-imports/no-unused-vars */
/* eslint-disable import/prefer-default-export */
import React, { useCallback, useEffect, useState } from 'react'
import LoadingSpinner from 'components/LoadingSpinner'
import clsx from 'clsx'
import { importAll } from 'helpers/util'
import s from './SubwayLines.module.css'

const subwayImages = importAll(require.context('images/subway/2x/', true, /\.png/))

export function SubwayLines({ options, initialValues, loading, onChange }) {
  const [selectedValues, setSelectedValues] = useState(initialValues)

  useEffect(() => {
    setSelectedValues(initialValues)
  }, [initialValues])

  const handleClearAll = () => {
    setSelectedValues([])
  }

  const handleApply = useCallback(() => {
    onChange?.(selectedValues)
  }, [onChange, selectedValues])

  return (
    <div className={s.root}>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <>
          <div className={s.subwayLines}>
            {options?.map(({ name, value }) => {
              const handleLineClick = () => {
                if (selectedValues.includes(value)) {
                  setSelectedValues(selectedValues.filter((line) => line !== value))
                } else {
                  setSelectedValues([...selectedValues, value])
                }
              }

              return (
                <div
                  key={value}
                  className={clsx(s.subwayLine, selectedValues.includes(value) && s.selected)}
                  data-testid={s.subwayLine}
                  onClick={handleLineClick}
                >
                  <img className={s.subwayLineImage} src={subwayImages[`./${name}.png`]} alt="subway" />
                </div>
              )
            })}
          </div>

          <div className={s.footer}>
            <button
              className={s.clearAll}
              type="button"
              onClick={handleClearAll}
              disabled={selectedValues?.length === 0}
            >
              Clear All
            </button>

            <div className={s.divider} />

            <button className={s.applyButton} type="button" onClick={handleApply}>
              Apply {selectedValues?.length > 0 && `(+${selectedValues?.length})`}
            </button>
          </div>
        </>
      )}
    </div>
  )
}
